import { SubscriptionUnit } from '../interfaces/plans.interface';

export const PLANS: SubscriptionUnit[] = [
  {
    id: 1,
    name: 'Basic plan',
    description: 'Free plan to test the application',
    motto: null,
    monthlyPrice: 0,
    isActive: false,
    isPopular: false,
    planFeature: [
      { name: 'Orders management', checked: true },
      { name: 'Customer management', checked: false },
      { name: 'Online-shop', checked: false },
      { name: 'POS-terminal', checked: false },
    ],
  },
  {
    id: 2,
    name: 'Super plan',
    description: 'Our most popular plan',
    motto: null,
    monthlyPrice: 20,
    isActive: false,
    isPopular: true,
    planFeature: [
      { name: 'Orders management', checked: true },
      { name: 'Customer management', checked: true },
      { name: 'Online-shop', checked: true },
      { name: 'POS-terminal', checked: false },
    ],
  },
  {
    id: 3,
    name: 'Business plan',
    description: 'Plan for your growing business',
    motto: null,
    monthlyPrice: 30,
    isActive: false,
    isPopular: false,
    planFeature: [
      { name: 'Orders management', checked: true },
      { name: 'Customer management', checked: true },
      { name: 'Online-shop', checked: true },
      { name: 'POS-terminal', checked: true },
    ],
  },
];
